import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { CoreModule } from 'src/app/core/core.module';
import { NgxMaskModule } from 'ngx-mask';
import { ModalMoreDetailsComponent } from './modal-more-details/modal-more-details.component';
import { EditFacModalComponent } from './edit-fac-modal.component';
import { ModalFilesUploadComponent } from './modal-files-upload/modal-files-upload.component';
import { ModalProductSearchComponent } from './modal-product-search/modal-product-search.component';
import { ModalSearchProfileComponent } from './modal-search-profile/modal-search-profile.component';
import { EditModalSearchProfileComponent } from './modal-search-profile/edit-modal-search-profile/edit-modal-search-profile.component';
import { EditFacModalService } from './service/edit-fac-modal.service';
import { FacsService } from 'src/app/facs/service/facs.service';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTimePickerModule, NZ_I18N, pt_BR } from 'ng-zorro-antd';
import { DiscardPopupComponent } from './modal-geral-chat/discard-popup/discard-popup.component';
import { TransferPopupComponent } from './modal-geral-chat/transfer-popup/transfer-popup.component';
import { ClientChatComponent } from './modal-geral-chat/client-chat/client-chat.component';
import { ModalLogComponent } from './modal-log/modal-log.component';
import { ModalGeralChatComponent } from './modal-geral-chat/modal-geral.component';
import { FacHistoryChatComponent } from './modal-geral-chat/fac-history-chat/fac-history.component';
import { ModalOfferedProductComponent } from './modal-geral-chat/modal-offered-product/modal-offered-product.component';
import { ModalOriginLeadComponent } from './modal-geral-chat/modal-origin-lead/modal-origin-lead.component';

@NgModule({
  declarations: [
    EditFacModalComponent,
    ModalMoreDetailsComponent,
    ModalFilesUploadComponent,
    ModalProductSearchComponent,
    ModalSearchProfileComponent,
    EditModalSearchProfileComponent,
    DiscardPopupComponent,
    TransferPopupComponent,
    ClientChatComponent,
    ModalOfferedProductComponent,
    ModalLogComponent,
    ModalGeralChatComponent,
    FacHistoryChatComponent,
    ModalOriginLeadComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    NgxMaskModule.forRoot({}),
    NzDatePickerModule,
    NzTimePickerModule
  ],
  exports: [
    EditFacModalComponent,
    ModalMoreDetailsComponent,
    ModalFilesUploadComponent,
    ModalProductSearchComponent,
    ModalSearchProfileComponent,
    EditModalSearchProfileComponent,
    ClientChatComponent,
    ModalOfferedProductComponent,
    ModalLogComponent,
    ModalGeralChatComponent,
    FacHistoryChatComponent,
    ModalOriginLeadComponent,
    TransferPopupComponent,
    DiscardPopupComponent
  ],
  providers: [
    EditFacModalService,
    FacsService,
    { provide: NZ_I18N, useValue: pt_BR }
  ]
})
export class EditFacModalModule { }
